<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    type: [String, Number],
    required: true,
  },
  options: {
    type: Array,
    required: true,   // باید حداقل 2 مقدار داشته باشد
    validator: opt => opt.length === 2,
  },
  size: {
    type: Number,
    default: 40        // ارتفاع و قطر دایره
  },
  activeColor: {
    type: String,
    default: "rgb(17 77 116)"
  },
  inactiveColor: {
    type: String,
    default: "#e0e0e0"
  },
  textColor: {
    type: String,
    default: "#333"
  }
});

const emit = defineEmits(["update:modelValue"]);

// پیدا کردن index گزینه فعلی
const index = computed(() =>
  props.options.findIndex(o => o.value === props.modelValue)
);

// حرکت بین دو مقدار
const toggle = () => {
  const next = (index.value + 1) % props.options.length;
  emit("update:modelValue", props.options[next].value);
};

// عرض کل = دو برابر دایره
// const width = computed(() => props.size * 2 + "px");
// const height = computed(() => );

const circleStyle = computed(() => ({
  width: (props.size - 6) + "px",
  height: (props.size - 6) + "px",
  left: index.value === 0 ? '0' : 'calc(100% - '+ props.size +'px)',
  // transform: index.value === 0 ? "translateX(0)" : `translateX(${props.size + 10}px)`,
  backgroundColor: props.activeColor,
  margin: '3px',
}));

const toggleContainerStype = computed(() => ({
  // 'padding-left': props.size/2 + "px",
  // 'padding-right': props.size/2 + "px",
  'height': props.size + "px"
}))

const labelStype = computed(() => ({
  'color': props.textColor,
  'padding-left': index.value === 0 ? (props.size/2)+5 + 'px' : '0',
  'padding-right': index.value === 0 ? '0' : (props.size/2)+5 + 'px',
}))
</script>

<template>
  <div class="toggle-container" :style="toggleContainerStype" @click="toggle">
    <div class="circle" :style="circleStyle"></div>

    <span class="label" :style="labelStype">
      {{ props.options[index]?.label }}
    </span>
  </div>
</template>

<style scoped>
.toggle-container {
  position: relative;
  border-radius: 50px;
  background-color: var(--inactive, #ccc);
  align-items: center;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  transition: background-color 0.3s ease;
  align-content: center;
  display: inline-block;
  min-width: 70px;
  padding: 0 15px;
}

.circle {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  transition: all .25s ease;
}

.label {
  position: relative;
  z-index: 3;
  font-size: 14px;
}
</style>
